import { lookupSelector } from '~store/lookupSelector';
import { selectRootState } from './root';

// Root: Slice Selectors
export const selectLocationState = lookupSelector(selectRootState, state => state.location);

// Slice: Location Selectors
export const selectLocationPageAlias = lookupSelector(selectLocationState, state => state.payload.pageAlias as string);
//export const selectLocationSlug = lookupSelector(selectLocationState, state => state.payload.slug);

export {};
